//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

//Material-ui
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';


//Part
import PartPageTitle from './PartPageTitle';

//Icon



class Comp extends React.Component {

  componentDidMount() {
    document.title = 'タイムラインの設定  - パートナーズ';
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'タイムラインの表示'}
          onback={ '/setting/' }
          helpType={ 'category' }
          helpFilter={ 'timeline' }
        />

        <div>
          <div style={{maxWidth:'400px', margin:'auto'}}>
            <div style={{padding:'10px'}}>
                あなたのアカウントの活動がタイムラインに表示するか設定できます。
            </div>
            <Grid container  justify="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
              <Grid
                item
                onClick={ () => this.props.settingTimelineEdit(0) }
                className='link'
                style={{fontSize:'1.2em', textDecoration:'underline'}}
              >
                非表示
              </Grid>
              <Grid item>
                <Switch
                  onChange={ (event) => this.props.settingTimelineEdit((event.target.checked ? 1 : 0)) }
                  checked={ (this.props.my.setting.timeline === 1) ? true : false }
                />
              </Grid>
              <Grid
                item
                onClick={ () => this.props.settingTimelineEdit(1) }
                className='link'
                style={{fontSize:'1.2em', textDecoration:'underline'}}
              >
                表示する
              </Grid>
            </Grid>
          </div>

        </div>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
